export default "__VITE_ASSET__DlGFOwIt__"